import { CartAddEvent, CartErrorEvent, CartUpdateEvent } from '@theme/events';

class PurchaseBlockingPopup extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        this.initEvents();
    }

    initEvents() {
        document.addEventListener('open-purchase-blocking-popup', () => this.open());
        this.querySelectorAll('.js-close-popup').forEach(btn => btn.addEventListener('click', () => this.close()));
        this.querySelector('.js-cart-clear')?.addEventListener('click', () => this.clearCart());
        this.querySelector('.popup__background')?.addEventListener('click', (e) => {
            if(e.target === this.querySelector('.popup__background')) {
                this.close();
            }
        });
    }

    clearCart() {
      if(this.dataset.cartType === 'local') {
        localStorage.removeItem('delivery-location');
        localStorage.removeItem('delivery-type');
        localStorage.removeItem('delivery-time');
      }
      fetch('/cart/clear.js', 
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((response) => {
            if (response.status) {
                this.dispatchEvent(
                new CartErrorEvent('cart-clear', response.message, response.description, response.errors)
                );
            } else {
                const sectionsToUpdate = document.getElementById('header-component')?.dataset.sectionId ? document.getElementById('header-component')?.dataset.sectionId : '';
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 
                        attributes: {
                            activeType: null
                        },
                        sections: sectionsToUpdate,
                        sections_url: window.location.pathname,
                    }) 
                  })
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                        this.dispatchEvent(
                        new CartErrorEvent('cart-attributes-clear', response.message, response.description, response.errors)
                        );
                    } else {
                         const newSectionHTML = new DOMParser().parseFromString(
                            response.sections[sectionsToUpdate],
                            'text/html'
                        );
                
                        
                        const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
                        const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;
                
                        this.dispatchEvent(
                            new CartUpdateEvent({}, sectionsToUpdate, {
                            itemCount: newCartItemCount,
                            source: 'cart-items-component',
                            sections: response.sections,
                            })
                        );
                        
                        this.close();
                        document.querySelector('[data-cart-type]')?.setAttribute('data-cart-type', '');
                        self.dispatchEvent(new CartAddEvent());
                    }
                });
            }
            
        });
    }

    open() {
        this.style.display = 'block';
    }

    close() {
        this.style.display = 'none';
    }
}

window.customElements.define('purchase-blocking-popup', PurchaseBlockingPopup);
